import mixitup from 'mixitup';
import mixitupPagination from './modules/_mixitup-pagination';
import 'jquery-match-height';
import Request from 'superagent';
import lscache from 'lscache';

(function($) {

	var personRecord = ({ person }) => {
		let alphaCharacter = (person.acf.sort_name.trim() !== '') ? person.acf.sort_name.trim().charAt(0) : 'Other';
		let sisterImage = (person.featured_image !== null && person.featured_image.medium !== null) ? person.featured_image.medium : '/wp-content/themes/wp-foundation-six/assets/images/png/cross.png';
		return `
		<div class="small-12 medium-6 large-3 end columns mix sister ${alphaCharacter}" data-id="${person.id}">
			<a href="${person.link}" class="sister-container match-height honor-${person.id}"  style="background-image: url(${sisterImage})"></a>

			<a href="${person.link}"><h6>${person.title.rendered}</h6></a>
		  </div>
		  `;

	};

	var alphaRecord = ({alphaChar, isLink}) => {
		let statusClass = isLink ? 'filter-active' : 'filter-inactive';
		return `<a class="filter-link ${statusClass}" data-sister-filter=".${alphaChar}">${alphaChar}</a>`;
	};

	$(document).ready(function() {

		$('.loader').hide();

		// Cache DOM & Global Variables
		let $sistersList = $('.sistersList');
		let $filters     = $('#filters');

		let cache = {};
		let mixer;


		// Executed Functions
		_initMixItUp();


		/**
		 * Init the Mix It Up plugin to
		 * Once initiated the the _buildScientistList function
		 * will start to append scientists
		 *
		*/
		function _initMixItUp(){
			mixitup.use(mixitupPagination);

			getData();
		}

		/**
		 * Builds the list of honor wall entries
		 *
		*/
		function _buildSisterList() {
			let alphaList = [];
			let sisters_data = cache.sort(function(a,b){
				if(a.acf.sort_name.trim() === '' || a.acf.sort_name.trim() === null) return 1;
				if(b.acf.sort_name.trim() === '' || b.acf.sort_name.trim() === null) return -1;
				if(a.acf.sort_name.trim() === b.acf.sort_name.trim()) return 0;
				return (a.acf.sort_name.trim() < b.acf.sort_name.trim()) ? -1 : 1;
			}).map(function(person){
				(person.acf.sort_name.trim() !== '') ? alphaList.push(person.acf.sort_name.trim().charAt(0)) : alphaList.push('Other');
				return personRecord({person});
			}).join('');

			_buildAlphaFilter(alphaList);
			//$sistersList.hide();
			$sistersList.append(sisters_data);


			mixer = mixitup($sistersList, {
				animation: {
					effects: 'fade scale translateX',
					duration: 500
				},
				callbacks: {
					onMixFail: function() { // state
						$('.fail-message').show();
					},
					onMixStart: function() { // state, futureState
						$('.fail-message').removeClass('hide');
						$('.fail-message').hide();
					},
					onMixEnd: function(){ // state
					}
				},
				pagination:{
					limit: 20,
					maintainActivePage: false
				},
				selectors: {
					target: '.sister'
				}
			});
			mixer.show().then(function(){
				$('.match-height').matchHeight({
					byRow: false,
					property: 'height',
					target: null,
					remove: false
				});
			});

		}

		function getData(){
			cache = lscache.get('mks_sisters_data');
			if (cache === null) {
				const url = '/wp-json/wp/v2/sisters/?per_page=100&';

				Request.get(url).then((response) => {
					const total_pages = parseInt(response.headers['x-wp-totalpages']);
					let all_entries = response.body;
					let response_count = 1;

					if ( response_count === total_pages ) {
						cache = all_entries;
						lscache.set('mks_sisters_data', all_entries, 1);
						_buildSisterList();
					}else{
						for ( let i = 2; i <= total_pages; i++ ) {
							Request.get(url).query('page=' + i).then((response) => {
								response_count++;
								all_entries = all_entries.concat(response.body);

								if ( response_count === total_pages ) {
									cache = all_entries;

									lscache.set('mks_sisters_data', all_entries, 30); //cache time
									_buildSisterList();
								}
							});
						}
					}
				});
			} else {
				cache = lscache.get('mks_sisters_data');
				_buildSisterList();
			}
		}

		function genCharArray(fisrt, last) {
			var arr = [], i = fisrt.charCodeAt(0), j = last.charCodeAt(0);
			for (; i <= j; ++i) {
				arr.push(String.fromCharCode(i));
			}
			return arr;
		}

		function _buildAlphaFilter(alphaList){
			let alphaArray = genCharArray('A', 'Z');
			let alphaHtml = '';
			//alphaArray.push('Other');
			alphaHtml = alphaArray.map(function(alphaChar){
				return alphaRecord({alphaChar, isLink: alphaList.indexOf(alphaChar) >= 0});
			}).join('');
			$filters.append(alphaHtml).removeClass('hide');
			$filters.children('a').on('click', function(event){
				event.preventDefault();
				if ($(this).hasClass('filter-active')){
					let filterChar = $(this).data('sisterFilter');
					$filters.children('a').removeClass('filter-current');
					$(this).addClass('filter-current');
					mixer.filter(filterChar);
				}
			});
		}

		/**
		 * Get the value of a querystring
		 *
		 * @param  {String} field The field to get the value of
		 * @param  {String} url   The URL to get the value from (optional)
		 * @return {String}       The field value
		 *
		 * @link https://gomakethings.com/how-to-get-the-value-of-a-querystring-with-native-javascript/
		*/
		// function _getQueryString(field, url) {
		// 	let href = url ? url : window.location.href;
		// 	let reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
		// 	let string = reg.exec(href);
		// 	return string ? string[1] : null;
		// }

	});
})(jQuery);




// WEBPACK FOOTER //
// ./theme_components/js/sisters-scripts.js